import { memo } from 'react';
//custom imports
import backIcon from '@src/assets/icons/back.svg';
import {history} from '@src/routes';
import {join} from '@src/utils/helpers';

const goback=( path ) => ( path ? history.push( path ) : history.go( -1 ) );

const BackButton=memo ( ({ path, className = '' })=>{
    return (
        <div className={join('core-back',className)}>
            <button onClick={ ()=> ( goback( path ) ) } className='no-button hover core-yellow-icon'>
                <img src={backIcon} alt="go back"/>
            </button>
        </div>
    )
}
)

export { BackButton };